// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import CommodityCodeShape from './prop_shapes/commodity_code'

class CommodityCodes extends React.Component {
  renderCommodityCode = commodityCode => (
    <span className='pro-label blue' key={`commodityCode-${commodityCode.id}`}>
      {commodityCode.name}
    </span>
  )

  render () {
    return (
      <div className='content'>
        <div className='small-12 cell'>
          {this.props.commodityCodes.map(cc => this.renderCommodityCode(cc))}
        </div>
      </div>
    )
  }
}

CommodityCodes.propTypes = {
  commodityCodes: PropTypes.arrayOf(CommodityCodeShape)
}

CommodityCodes.defaultProps = {
  commodityCodes: []
}

export default CommodityCodes
